import { render, staticRenderFns } from "./ElInputDayWeek.vue?vue&type=template&id=8d236c54"
import script from "./ElInputDayWeek.vue?vue&type=script&lang=js"
export * from "./ElInputDayWeek.vue?vue&type=script&lang=js"
import style0 from "./ElInputDayWeek.vue?vue&type=style&index=0&id=8d236c54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports